import { render, staticRenderFns } from "./SalonsList.vue?vue&type=template&id=e81b9b52&scoped=true&"
import script from "./SalonsList.vue?vue&type=script&lang=js&"
export * from "./SalonsList.vue?vue&type=script&lang=js&"
import style0 from "./SalonsList.vue?vue&type=style&index=0&id=e81b9b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b9b52",
  null
  
)

export default component.exports